import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { size } from 'lodash/fp';
import { DescriptionItem } from '@mews-commander/ui';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { ApplicationState, OrderItem } from '@mews-commander/types';
import { getServiceTimeUnitPluralKey } from '@mews-commander/legacy-entities/src/utils/serviceTimeUnitLocalization';
import {
    getSortedActiveDefaultProductOrderItems,
    getSortedNonCanceledReservationsAdditionalExpenses,
} from '../../selectors/orderItems';
import DefaultProductOrderItemsList from './DefaultProductOrderItemsList/DefaultProductOrderItemsList';
import ProductOrders from './ProductOrders';
import { AdditionalExpensesList } from './AdditionalExpensesList';

interface OwnProps {
    reservationId: string;
    serviceId: string;
    scope: string;
    isFetching: boolean;
}
interface StateProps {
    timeUnitKeyPlural: Mews.TextKey | undefined;
    additionalExpenses: OrderItem[];
    defaultProductOrderItems: OrderItem[];
}
type Props = StateProps & OwnProps;

const ReservationOrderItems = ({
    reservationId,
    serviceId,
    timeUnitKeyPlural,
    isFetching,
    additionalExpenses,
    defaultProductOrderItems,
}: Props) =>
    !isFetching ? (
        <>
            {size(defaultProductOrderItems) > 0 ? (
                <DescriptionItem
                    data-test-id="timeUnits"
                    term={timeUnitKeyPlural ? <LocalizedText textKey={timeUnitKeyPlural} /> : null}
                    definition={
                        <DefaultProductOrderItemsList nights={defaultProductOrderItems} serviceId={serviceId} />
                    }
                />
            ) : null}
            <ProductOrders serviceOrderId={reservationId} serviceId={serviceId} />
            {size(additionalExpenses) > 0 ? (
                <DescriptionItem
                    data-test-id="additionalExpenses"
                    term={<LocalizedText textKey={TextKey.AdditionalExpensePlural} />}
                    definition={
                        <AdditionalExpensesList additionalExpenses={additionalExpenses} serviceId={serviceId} />
                    }
                />
            ) : null}
        </>
    ) : null;

export default connect<StateProps, {}, OwnProps, ApplicationState>(
    createStructuredSelector({
        additionalExpenses: (state: ApplicationState, { reservationId }: OwnProps) =>
            getSortedNonCanceledReservationsAdditionalExpenses(state, { serviceOrderIds: [reservationId] }),
        defaultProductOrderItems: (state, { reservationId, serviceId }) =>
            getSortedActiveDefaultProductOrderItems(state, { serviceId, serviceOrderIds: [reservationId] }),
        timeUnitKeyPlural: (state, { serviceId }) => getServiceTimeUnitPluralKey(state, { id: serviceId }),
    })
)(ReservationOrderItems);
